import { render, staticRenderFns } from "./SinMateria.vue?vue&type=template&id=0ab16528&"
import script from "./SinMateria.vue?vue&type=script&lang=js&"
export * from "./SinMateria.vue?vue&type=script&lang=js&"
import style0 from "./SinMateria.vue?vue&type=style&index=0&id=0ab16528&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports